import {AnyAction} from 'redux';
import {ThunkAction} from 'redux-thunk';

import {initTitle} from '../../../entities/layout/initTitle';
import {State} from '../../../store/initialState';


export const initHomeGoodTitle = (): ThunkAction<void, State, unknown, AnyAction> => initTitle('homeGood.head.title');
